import styled from 'styled-components';

export const ModalContent = styled.div`
  margin: -32px -48px -48px -48px;
  display: flex;
  flex-direction: column;
  max-width: 520px;
  line-height: 22px;
  vertical-align: middle;
`;

export const InfoSection = styled.div`
  margin: 24px;
  width: 472px;
  border-radius: 10px;
  gap: 9px;
  border-width: 1px;
  padding: 10px 20px 30px 10px;
  border: 1px solid #d9d9d9;
  text-align: left;
  display: flex;
  align-items: flex-start;
  > svg {
    flex: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BoldMessage = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

export const InfoMessage = styled.p`
  font-size: 14px;
  font-weight: 300;
  flex-grow: 1;
  &.error-message {
    color: #d93f21;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  border-top: 1px solid #f2f2f2;
  padding: 20px;
`;

export const StyledButton = styled.button`
  padding: 0.5rem 0.8rem;
  min-width: 4.5rem;
  text-align: center;
  font-weight: 500;
  height: 100%;
  background: var(--pixelme-color);
  color: var(--white);
  border: none;
  border-radius: 0.2rem;
  text-decoration: none !important;

  &:hover {
    color: var(--white);
    background: #424fff;
    cursor: pointer;
  }

  &:disabled {
    background: #0e5396;
    color: var(--white);
  }
`;
